module.exports = __webpack_public_path__ + "static/img/PH.f89f03f2.svg";